import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchContact } from "#modules/contacts/infra/fetchContact.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const contactQuery = (id: string | undefined) => ({
  queryKey: queryKeys.contacts.detail(id),
  queryFn: () => fetchContact(id),
  staleTime: STALE_TIME,
  enabled: !!id,
});
